import styled from 'styled-components';

import { DeviceSizes } from 'beek-design-system';
import { IMAGE_CDN_URL } from 'beek-design-system/utils/env';
import Footer from 'src/components/Common/Footer';
import Head, { Metadata } from 'src/components/Common/CommonHead/CommonHead';

const getMetadata = (): Metadata => {
  const metadata = {
    title: 'Beek: Audiolibros y meditaciones sin límites',
    author: 'Beek',
    orgAuthor: 'Beek',
    description:
      'Descarga, escucha y aprende sin cambiar tu rutina con los mejores expertos en finanzas, salud, bienestar, auto ayuda y más.',
    date: '2020-03-02',
    category: 'Audiobooks',
    cover: `${IMAGE_CDN_URL}/image/landing_page/beek-meta-image.webp?width=1200&height=630&quality=75&format=jpg`,
    url: `https://beek.io`,
    tags: 'Beek',
  };

  return metadata;
};

type LayoutProps = {
  children: JSX.Element;
  hasFooter?: boolean;
};

const defaultProps = {
  hasFooter: true,
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  @media ${DeviceSizes.laptop} {
    overflow-x: hidden;
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

const Layout = ({ hasFooter = true, children }: LayoutProps): JSX.Element => {
  const metaData = getMetadata();
  return (
    <>
      <Head metadata={metaData} />
      <Container>{children}</Container>
      {hasFooter && <Footer />}
    </>
  );
};

Layout.defaultProps = defaultProps;
export default Layout;
